var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_512_550)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4205 13.4682C15.702 14.1127 15.3154 15.0553 15.3338 16.2968C15.3522 17.4777 15.6972 18.2443 16.4716 19.0487C16.484 19.0616 16.4965 19.0745 16.5089 19.0874C16.9239 19.5177 17.326 19.9346 17.5972 20.4981C17.8847 21.0951 18.0007 21.7937 18.0002 22.7696C18 23.1519 17.7014 23.4617 17.3333 23.4615C16.9651 23.4613 16.6669 23.1512 16.667 22.7689C16.6675 21.8986 16.5617 21.4433 16.4048 21.1173C16.2398 20.7745 15.9909 20.5071 15.5293 20.0282L15.5291 20.028C14.5262 18.9863 14.0251 17.8829 14.0008 16.3189L14.0008 16.3184C13.9774 14.7445 14.4796 13.3796 15.5491 12.4203C16.6034 11.4746 18.1232 11 20 11C21.8771 11 23.3974 11.4745 24.4518 12.4203C25.5215 13.3796 26.0235 14.7448 25.9992 16.3188C25.9758 17.8832 25.4735 18.9865 24.4711 20.0278C24.0104 20.5067 23.7617 20.7742 23.5965 21.1173C23.4394 21.4437 23.3333 21.8993 23.3329 22.7696C23.3327 23.1519 23.0341 23.4617 22.666 23.4615C22.2978 23.4613 21.9995 23.1512 21.9997 22.7689C22.0002 21.793 22.1168 21.0948 22.4041 20.4981C22.675 19.9354 23.0759 19.5188 23.4898 19.0888C23.5025 19.0756 23.5152 19.0624 23.5279 19.0492L23.5281 19.0489C24.303 18.2442 24.6486 17.4775 24.6661 16.297L24.6662 16.2966C24.6854 15.0552 24.299 14.1127 23.5805 13.4682C22.8467 12.8101 21.6789 12.3846 20 12.3846C18.3216 12.3846 17.1542 12.81 16.4205 13.4682ZM16.667 25.5385C16.667 25.1561 16.9655 24.8462 17.3336 24.8462H22.6663C23.0345 24.8462 23.3329 25.1561 23.3329 25.5385C23.3329 25.9208 23.0345 26.2308 22.6663 26.2308H17.3336C16.9655 26.2308 16.667 25.9208 16.667 25.5385ZM17.5558 28.3077C17.5558 27.9253 17.8543 27.6154 18.2224 27.6154H21.7775C22.1457 27.6154 22.4441 27.9253 22.4441 28.3077C22.4441 28.69 22.1457 29 21.7775 29H18.2224C17.8543 29 17.5558 28.69 17.5558 28.3077Z",
    fill: "#ECCFA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_550",
    x: 14,
    y: 11,
    width: 12,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_550",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#975B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B36996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37790"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.4c2256d241902b147775e792ebc405e1.svg";
export { ForwardRef as ReactComponent };